<template>
    <div
        class="notice"
        :class="[messageType, {'with-margin': withMargin, 'clickable': this.clickable}]">
        <span class="notice__message" v-if="message">{{ message }}</span>
        <slot name="message-list"></slot>
        <slot></slot>
        <button
            type="button"
            class="notice__button"
            @click="$emit('on-close')"
            v-if="dismissable">
            <i class="fa fa-close"></i>
        </button>
    </div>
</template>

<style lang="scss">
    @import "../../styles/_variables.scss";
    .notice {
        padding: 12px 15px;
        width: 100%;
        background: #E1F1F9;
        border-radius: 3px;
        border: 1px solid #BED1DA;
        color: #55788A;
        position: relative;

        &.clickable {
            -webkit-transition: background .2s ease;
                    transition: background .2s ease;
            &:hover {
                cursor: pointer;
                background: lighten(#E1F1F9, 3%);
            }
        }

        &__message { display: block; }

        &--danger {
            background: $danger-color;
            color: #FFF;
            border-color: darken($danger-color, 10%);
        }

        &--success {
            background: $success-color;
            color: #FFF;
            border-color: darken($success-color, 10%);
        }

        &--warning {
            background: $warning-color;
            color: #FFF;
            border-color: darken($warning-color, 10%);
        }

        &.with-margin { margin-bottom: 30px; }

        &__button {
            padding: 0;
            margin: 0;
            border: none;
            background: transparent;
            outline: 0;
            position: absolute;
            right: 15px;
            top: 15px;
            font-weight: bold;
            color: inherit;

            i { margin: 0; }
        }
    }
</style>

<script>
    export default {
        props: {
            show: {
                type: Boolean,
                required: false,
                default: true
            },
            clickable: {
                type: Boolean,
                required: false,
                default: false
            },
            message: {
                type: String,
                required: false
            },
            type: {
                type: String,
                required: false,
                default: 'default'
            },
            dismissable: {
                type: Boolean,
                required: false,
                default: false
            },
            withMargin: {
                type: Boolean,
                required: false,
                default: true
            }
        },
        computed: {
            messageType () {
                switch (this.type) {
                    case 'danger':
                        return 'notice--danger'
                    case 'success':
                        return 'notice--success'
                    case 'warning':
                        return 'notice--warning'
                    default:
                        return 'notice--normal'
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/general/Notice.vue